import React from 'react';
import styled, { css } from 'styled-components';

interface ButtonProps {
  fileInput?: boolean;
  fn?: any;
  text?: string;
  checked?: boolean;
  disabled?: boolean;
  btnName?: 'btn-round02' | 'btn-round03' | 'btn-round04' | 'btn-round06' | 'btn-file01';
  type?: string;
}

const Button = styled.button<{ disabled?: boolean }>`
  font-size: 1.125rem;
  font-family: 'SDGothicNeobTTF-bLt';
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  word-wrap: break-word;

  ${props =>
    props.disabled &&
    css`
      min-width: 11.25rem;
      padding: 1.1875rem 1.875rem 1.0625rem;
      border-radius: 3.75rem;
      border: 1px solid #e5e5e5;
      background: #e5e5e5;
      box-sizing: border-box;
      position: relative;
      color: #999;
      &:hover {
        border: 1px solid #e5e5e5;
        background: #e5e5e5;
        span {
          color: #999;
        }
      }
    `}

  &.btn-round06 {
    min-width: 180px;
    min-width: 11.25rem;
    padding: 1.1875rem 1.875rem 1.0625rem;
    border-radius: 3.75rem;
    border: 1px solid #ff671d;
    color: #ff671d;
    &:focus,
    &:hover {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      color: #fff;
      border: 1px solid #ff671d;
      background-color: #ff671d;
    }
  }
  &.btn-round04 {
    min-width: 11.25rem;
    padding: 1.1875rem 1.875rem 1.0625rem;
    border-radius: 3.75rem;
    border: 1px solid #ccc;
    &:hover,
    &:focus {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      border: 1px solid #ff671d;
      background-color: #ff671d;
      color: #fff;
    }
  }
  &.btn-round03 {
    min-width: 11.25rem;
    padding: 1.1875rem 1.875rem 1.0625rem;
    border-radius: 60px;
    border-radius: 3.75rem;
    border: 1px solid #ff671d;
    background-color: #ff671d;
    position: relative;
    display: block;
    color: #fff;
    &:hover,
    &:focus {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      border: 1px solid #ff5000;
      background-color: #ff5000;
    }
  }

  &.btn-round02 {
    min-width: 11.25rem;
    padding: 1.1875rem 1.875rem 1.0625rem;
    border-radius: 3.75rem;
    border: 1px solid #ccc;
    &:hover,
    &:focus {
      border: 1px solid #ff671d;
      background-color: #ff671d;
      color: #fff;
    }
  }
`;

const FileButton = styled.label<{ disabled?: boolean }>`
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 15px 30px 12px;
  min-width: 100px;

  box-sizing: border-box;
  border-radius: 8px;

  ${props =>
    props.disabled &&
    css`
      border: 1px solid #e5e5e5 !important;
      background: #e5e5e5;
      box-sizing: border-box;
      position: relative;
      span {
        color: #999;
      }
      &:hover {
        border: 1px solid #e5e5e5 !important;
        background: #e5e5e5 !important;
        span {
          color: #999 !important;
        }
      }
    `}

  &.btn-file01 {
    border: 1px solid #ff671d;

    &:hover,
    &:focus {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      border: 1px solid #ff671d;
      background-color: #ff671d;
      span {
        color: #fff;
      }
    }
  }
`;

const Text = styled.span`
  position: relative;
  display: block;
  font-size: 1.125rem;
  font-family: 'SDGothicNeobTTF-bLt';
  word-break: keep-all;
  word-wrap: break-word;
  color: #ff671d;
`;

const CustomButton: React.FC<ButtonProps> = ({ text, fn, disabled, btnName, fileInput, type }) => {
  const handleClick = (val?: any) => {
    if (disabled) {
      return;
    }

    if (fn) {
      fn(val);
    }
  };

  const handleFileChange = (e: any) => {
    if (fn) {
      fn(e);
    }
  };

  return fileInput ? (
    <>
      <FileButton className={btnName} htmlFor="file-btn" disabled={disabled}>
        <Text className="txt">{text}</Text>
      </FileButton>

      {!disabled && <input type="file" id="file-btn" hidden onChange={handleFileChange} />}
    </>
  ) : (
    <Button type={type as any} className={btnName} onClick={() => handleClick()} disabled={disabled}>
      {text}
    </Button>
  );
};

export default CustomButton;
